/*
 * Copyright (c) 2022 CalAmp Corp.  All Rights Reserved
 */
import React, {useCallback} from 'react';
import isUndefined from 'lodash.isundefined';
import {translate} from '@ion/core/src/locale/locale';
import {GenericObject, SCIDeviceType} from '@ion/core/src/types/entities';
import {BulkSCIStyleProps} from './BulkSCISettings';
import {SCIAdvanceTab} from './SCIAdvanceTab';
import {
  defaultReceiveInterval,
  defaultReceiveTime,
  getBulkSelectedValue
} from './SCISettingsUtils';

export interface BulkSCIAdvanceTabProps extends BulkSCIStyleProps {
  classes: {
    [key: string]: string;
  };
  deviceModel: string;
  advanceTabFields: GenericObject[];
  customTabFields: GenericObject[];
  setCustomTabFields: Function;
  handleAdvanceFieldChange: Function;
  setAdvanceTabFields: Function;
}

/**
 * Edit Advance settings for SCI Devices in bulk
 */
export function BulkSCIAdvanceTab({
  classes,
  deviceModel,
  advanceTabFields,
  customTabFields,
  setCustomTabFields,
  setAdvanceTabFields,
  handleAdvanceFieldChange,
  isBulkAction = false
}: BulkSCIAdvanceTabProps) {
  const onRadioChange = useCallback((e, key, label) => {
    const initialControlData = customTabFields;
    initialControlData.find(switchItem => switchItem.label === label)[key] = getBulkSelectedValue(e?.target?.value);
    setCustomTabFields([...initialControlData]);
  }, []);

  const isTagDetectionOn = useCallback((): boolean => {
    let isTagDetectionOn = false;
    let tagDetectionObj;
    if (Array.isArray(customTabFields) && customTabFields.length > 0) {
      tagDetectionObj = customTabFields.filter((item) => item.zMicroDetection);
      if (isUndefined(tagDetectionObj)) {
        isTagDetectionOn = true;
      } else {
        isTagDetectionOn = tagDetectionObj.length > 0 && tagDetectionObj[0]?.zMicroDetection;
      }
    }
    if (deviceModel === SCIDeviceType.STAG09XT) {
      isTagDetectionOn = true;
    }
    return isTagDetectionOn;
  }, []);

  function handleTagDetectionMode(e) {
    const initialAdvanceData = advanceTabFields;
    const activeAdvanceSubTab = advanceTabFields[1];
    let changedArray= [];
    changedArray = activeAdvanceSubTab.map(field => {
      if (field.label === translate('admin-devices:view.sciSettings.receiveInterval')) {
        return {...field, zMicroRxPeriod: defaultReceiveInterval[e.target.value]};
      }
      if (field.label === translate('admin-devices:view.sciSettings.receiveTime')) {
        return {...field, zMicroRxTime: defaultReceiveTime[e.target.value]};
      }
      return field;
    });
    initialAdvanceData[1] = changedArray;
    setAdvanceTabFields([...initialAdvanceData]);
  };

  return (
    <SCIAdvanceTab bulkSCI
      deviceModel={deviceModel}
      advanceTabFields={advanceTabFields}
      classes={classes}
      handleCustomSwitchChange={onRadioChange}
      handleAdvanceFieldChange={handleAdvanceFieldChange}
      noUpdate={false}
      sciPendingSettingData={{}}
      isTagDetectionOn={isTagDetectionOn()}
      initialAdvance={false}
      handleTagDetectionMode={handleTagDetectionMode}
      isBulkAction={isBulkAction} />
  );
};

export default BulkSCIAdvanceTab;
